import { NextRouter } from 'next/router';
import { create } from 'zustand';

import { updateFilters } from 'layout/Listing/hooks/useUpdateFilters';

interface VideosListingStore {
  search: string;
  filters: string;
}

export const videosFilterDefaultState = {
  search: '',
  filters: 'All',
};

const useVideosListingStore = create<VideosListingStore>(() => videosFilterDefaultState);

export const updateVideosFilters = (router: NextRouter, value: string) => {
  useVideosListingStore.setState(() => ({ filters: value }));
  updateFilters(router, { category: value });
};

export const setVideosSearch = (search: string) => {
  useVideosListingStore.setState(() => ({ search }));
};

export const clearVideosFilters = () => {
  useVideosListingStore.setState(() => videosFilterDefaultState);
};

export default useVideosListingStore;
